import Image from "next/image";
import { RESULTS, RESULTS_CODA, SECTION_IDS } from "./content";

export const Results = () => (
  <section
    id={SECTION_IDS.results}
    className="relative overflow-hidden px-[clamp(16px,4vw,64px)] py-[clamp(120px,17vw,260px)]"
  >
    <div className="absolute inset-0">
      <Image
        src="/images/satellitewave-halftone-bluegreen.webp"
        alt=""
        fill
        sizes="100vw"
        className="object-cover opacity-[.22] saturate-[.6]"
      />
      <div className="absolute inset-0 bg-[radial-gradient(90%_70%_at_30%_50%,rgba(3,12,22,.55),#030C16_78%)]" />
    </div>

    <div className="dc-shell relative z-2">
      <h2 className="m-0 text-[clamp(46px,10.4vw,188px)] font-bold leading-[.84] tracking-[-.05em]">
        YOU KNOW,
        <br />
        RATHER THAN
        <br />
        <span className="text-ember">ASSUME.</span>
      </h2>

      {/* Stacked below xl in the design's order (tagline, cards, closing line);
          from xl the outcomes take the right-hand column. */}
      <div className="mt-[clamp(56px,7vw,96px)] grid items-start gap-x-[clamp(48px,6vw,120px)] gap-y-[clamp(64px,9vw,140px)] xl:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <p className="dc-mono m-0 max-w-[40ch] text-[clamp(13px,1.2vw,17px)] uppercase leading-[2.3] tracking-[.14em] text-mist-1">
          Current information. Evidence behind it. Available when the question
          comes up.
        </p>

        <div className="grid max-w-[900px] grid-cols-1 gap-x-[clamp(32px,4vw,80px)] gap-y-[clamp(32px,4vw,60px)] md:grid-cols-2 xl:col-start-2 xl:row-span-2 xl:row-start-1 xl:max-w-none">
          {RESULTS.map((result) => (
            <div
              key={result.title}
              className="border-t border-white/20 pt-[26px]"
            >
              <h3 className="mt-0 mb-[18px] text-[clamp(17px,1.5vw,21px)] font-semibold uppercase tracking-[.04em] text-paper">
                {result.title}
              </h3>
              <p className="m-0 text-[17px] leading-[1.7] text-mist-3">
                {result.body}
              </p>
            </div>
          ))}
        </div>

        {/* Closing line — carried over from v1 of the design */}
        <p className="m-0 max-w-[60ch] text-[clamp(16px,1.4vw,19px)] leading-[1.7] text-mist-1 xl:col-start-1 xl:row-start-2 xl:self-end">
          {RESULTS_CODA}
        </p>
      </div>
    </div>
  </section>
);
